/**
 * AlmadarPostLearningFromInterruptionsARAlmadarPostLearningFromInterruptionsARPage
 *
 * Page component for AlmadarPostLearningFromInterruptionsARAlmadarPostLearningFromInterruptionsARPage
 * Path: /ar/blog/learning-from-interruptions
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostLearningFromInterruptionsARPostPageView as __AlmadarPostLearningFromInterruptionsARPostPageView } from '@/components/traits/AlmadarPostLearningFromInterruptionsARPostPageView';
import { AlmadarPostLearningFromInterruptionsARPostAnalyticsView as __AlmadarPostLearningFromInterruptionsARPostAnalyticsView } from '@/components/traits/AlmadarPostLearningFromInterruptionsARPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostLearningFromInterruptionsARAlmadarPostLearningFromInterruptionsARPageProps {
  // Add any page-level props here
}

export function AlmadarPostLearningFromInterruptionsARAlmadarPostLearningFromInterruptionsARPage(_props: AlmadarPostLearningFromInterruptionsARAlmadarPostLearningFromInterruptionsARPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostLearningFromInterruptionsARPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostLearningFromInterruptionsARPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostLearningFromInterruptionsARAlmadarPostLearningFromInterruptionsARPage;
